module.exports = __webpack_public_path__ + "5660a8cb05679570bf433b63642d6a80.png";